const size = {
  mobileS: '320px',
  mobileM: '420px',
  mobileL: '680px',
  tablet: '768px',
  laptop: '1024px',
  laptopM: '1200px',
  laptopL: '1450px',
  desktop: '1740px',
  desktopM: '1920px',
  desktopL: '2560px'
}

export default {
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopM: `(max-width: ${size.laptopM})`,
  laptopL: `(max-width: ${size.laptopL})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopM: `(max-width: ${size.desktopM})`,
  desktopL: `(max-width: ${size.desktopL})`
};